//////////////
// NetX extensions to FormValidation:
//
// numberAttr is a validator for DAM number attributes.
//
////////
// all-in-one number attribute validator!
//
// Form validation
// If you are not logged in, we start right off from the get go with a form
import 'core-libs/formValidation/dist/js/formValidation';
import 'core-libs/formValidation/dist/js/framework/bootstrap';

import {isEmptyValue} from '@netx/core/lib/underscore-netx';

/**
 * @method
 * @param {array} results Query results
 * @return {array} Parsed query results
 */
const LVBHandler = function(results) {
	// Sort
	results = _.sortBy(results, v => v.label);
	return _.map(results, r => {
		return {id: r.value, text: r.label};
	});
};

import {getCompletion, inquiry} from '@netx/core/lib/netx-autocomplete';

// Support case insensitivity
FormValidation.Validator.regexp.validate = function (
	validator,
	$field,
	options,
) {
	// Original code
	// var value = validator.getFieldValue($field, 'regexp');
	// if (value === '') {
	// 	return true;
	// }
	//var regexp = ('string' === typeof options.regexp) ? new RegExp(options.regexp) : options.regexp;
	//return regexp.test(value);

	// New code

	// Vars
	var insensitive, regexp, value;

	value = validator.getFieldValue($field, 'regexp');
	if (value === '') {
		return true;
	}

	insensitive = $field.attr('data-nx-fv-caseInsensitive');

	if (_.isString(options.regexp)) {
		if (insensitive) {
			regexp = new RegExp(options.regexp, 'i');
		} else {
			regexp = new RegExp(options.regexp);
		}
	} else {
		regexp = options.regexp;
	}
	return regexp.test(value);
};

FormValidation.Validator.lookup = {
	html5Attributes: {
		message: 'message',
		completion: 'completion'
	},

	validate(validator, $field, options, validatorName) {
		const value = validator.getFieldValue($field, validatorName).toLowerCase().trim();
		if (value === '') return true;

		const deferred = new $.Deferred();

		const completion = getCompletion({completion: options.completion, LVBHandler});
		inquiry(completion.completion, value, completion.extra, completion).then((results) => {
			if (results.some(result => results[0].text.toLowerCase() === value)) {
				deferred.resolve($field, validatorName, {valid: false, message: options.message || "Name already exists"});
				return;
			}
			deferred.resolve($field, validatorName, {valid: true});
		});

		return deferred;
	}
}

// Enforce entering a value or opting to clear the value
FormValidation.Validator.attributeProfile = {
	validate: function(validator, $field, options, validatorName) {
		options = options || {};
		var message = options.message;
		var value = validator.getFieldValue($field, validatorName);
		var valid = true;

		var cleared = $field.closest('.form-group').find('[data-nx-control="clear-toggle"]:checked').length > 0;
		if (isEmptyValue(value) && !cleared) {
			message = i18n.t('app:i18n.validationProfileAttributeInvalid');
			valid = false;
		}

		return {
			valid: valid,
			message: message
		};
	}
};

FormValidation.Validator.numberAttr = {
	html5Attributes: {
		message: 'message',
		trim: 'trim',
		size: 'size',
		type: 'type',
		spec1: 'spec1',
		spec2: 'spec2'
	},
	/**
	 * Validate a DAM number field.
	 *
	 * @param {FormValidation.Base} validator The validator plugin instance
	 * @param {jQuery} $field Field element
	 * @param {Object} options Consists of following keys:
	 * -size
	 * -type
	 * -spec1
	 * -spec2
	 * - message: The invalid message
	 * - trim: Indicate the length will be calculated after trimming the value or not. It is false, by default
	 *
	 *  Keys 'size' & 'spec1' are interchangeable.  Keys 'type' & 'spec2' are also interchangeable.
	 *  At least 'type' (or 'spec1') must be defined.
	 *
	 *  Validation rules:
	 * * We only test size on integer types (type 0 and type 5)
	 * * When testing size, we count number of digits; decimal point doesn't count.
	 * * If size = 0, or not specified as an option, then any length is okay.
	 * * For types 1-3, we test that the value has only that many digits (or less) after the decimal point (if any).
	 * * Integer types cannot have decimal points (but the others can.)
	 *
	 * At least one of two keys is required
	 * The min, max keys define the number which the field value compares to. min, max can be
	 *      - A number
	 *      - Name of field which its value defines the number
	 *      - Name of callback function that returns the number
	 *      - A callback function that returns the number
	 *
	 * @returns {Object}
	 */
	validate: function(validator, $field, options) {
		options = options || {};
		var value = validator.getFieldValue($field, 'numberAttr');

		if (options.trim === true || options.trim === 'true') {
			value = $.trim(value);
		}

		if (value === '') {
			return true;
		}

		var isValid = true,
			locale  = validator.getLocale(),
			message = options.message || i18n.t('i18n.validationNumberInvalidLength'),
			size    = $.isNumeric( options.size )  ? options.size  : validator.getDynamicOption( $field, options.size ),
			type    = $.isNumeric( options.type )  ? options.type  : validator.getDynamicOption( $field, options.type ),
			spec1   = $.isNumeric( options.spec1 ) ? options.spec1 : validator.getDynamicOption( $field, options.spec1 ),
			spec2   = $.isNumeric( options.spec2 ) ? options.spec2 : validator.getDynamicOption( $field, options.spec2 ),
			// Credit to http://stackoverflow.com/a/23329386 (@lovasoa) for UTF-8 byte length code
			utf8Length = function(str) {
				var s = str.length;
				for (var i = str.length - 1; i >= 0; i--) {
					var code = str.charCodeAt(i);
					if (code > 0x7f && code <= 0x7ff) {
						s++;
					}
					else if ( code > 0x7ff && code <= 0xffff ) {
						s += 2;
					}
					if (code >= 0xDC00 && code <= 0xDFFF) {
						i--;
					}
				}
				return s;
			}, numLength;

		// size can be size or spec1
		if ( spec1 && !size ) {
			size = spec1;
		}

		// type can be type or spec2
		if ( spec2 && !type ) {
			type = spec2;
		}

		// without type, we can't really validate anything.
		if ( !_.isNumeric( type ) ) {
			return true;
		}
		//////
		// Size test:
		//
		// If type is 'whole number' (type == 0, because that means "0 decimal points allowed"),
		// or 'sortable' (type == 5, because nothing's that simple).
		// and size is not 0, test length against 'size' option
		//
		if ( (type == 0 || type == 5 ) && _.isNumeric( size ) && size > 0) {
			// for number attrs, we measure length without decimal point:
			numLength = value.replace('.', '').length;

			if (size && numLength > parseInt(size, 10)) {
				isValid = false;
				message = options.message || i18n.t('i18n.validationNumberLessDigits', { count: parseInt( size, 10 ) } );
			}
		}

		return {
			valid: isValid,
			message: message
		};
	}
};

const originalStringLengthValidate = FormValidation.Validator.stringLength.validate;
FormValidation.Validator.stringLength.validate = (validator, $field, options, validatorName) => {
	const result = originalStringLengthValidate.call(FormValidation.Validator.stringLength, validator, $field, options, validatorName);
	
	if (result !== true && result.valid !== true && $field.attr('type') === 'password') {
		const min = $.isNumeric(options.min) ? options.min : validator.getDynamicOption($field, options.min);
		result.message = i18n.t('i18n.pleaseEnterAtLeastNCharacters', {count: min});
	}

	return result;
}

// Do not handle disabling enabling of our submit buttons
FormValidation.Framework.Bootstrap.prototype.disableSubmitButtons = function() {
	return this;
};

// FV's destroy() method breaks if we re-render any form element after validation has been added.
// Here is a workaround, but really this should be fixed in the plugin itself:
// https://github.com/formvalidation/support/issues/488
FormValidation.Base.prototype.destroy = FormValidation.Framework.Bootstrap.prototype.destroy = _.wrap( FormValidation.Base.prototype.destroy, function(destroy) {
	var ns = 'fv';
	for ( var field in this.options.fields ) {
		var fields = this.getFieldElements(field);
		var row    = this.options.fields[field].row || this.options.row.selector;
		for (var i = 0; i < fields.length; i++) {
				var $field = fields.eq(i);
				// FV calls $field.data(ns + '.messages') and then expects jQuery functions to exist on the resulting object.
				// but if we've re-rendered, no such object exists.
				// Here we add a dummy empty jQ object, just to prevent that failure.
				var f = $field.data(ns + '.messages');
				if (!f) {
					// http://stackoverflow.com/questions/1228474/jquery-empty-selector-null-selector
					$field.data(ns + '.messages', $());
				}
		}
	}
	return destroy.apply(this, _.rest(arguments));
});

// It actually occurs in updateStatus which can get called from other parts than just the destroy method
FormValidation.Base.prototype.updateStatus = FormValidation.Framework.Bootstrap.prototype.updateStatus = _.wrap( FormValidation.Base.prototype.updateStatus, function( updateStatus ) {
	var ns = 'fv';
	for ( var field in this.options.fields ) {
		var fields = this.getFieldElements(field);
		var row    = this.options.fields[field].row || this.options.row.selector;
		for (var i = 0; i < fields.length; i++) {
				var $field = fields.eq(i);
				// FV calls $field.data(ns + '.messages') and then expects jQuery functions to exist on the resulting object.
				// but if we've re-rendered, no such object exists.
				// Here we add a dummy empty jQ object, just to prevent that failure.
				var f = $field.data(ns + '.messages');
				if (!f) {
					// http://stackoverflow.com/questions/1228474/jquery-empty-selector-null-selector
					$field.data(ns + '.messages', $());
				}
		}
	}
	return updateStatus.apply( this, _.rest( arguments ) );
} );

export default FormValidation;